import React from 'react'

import { ROUTE_NAME, API_URL } from '../constants'

import ItemDelete from '../../components/Delete'

const AILayerDelete = () => (
  <ItemDelete
    routeName={ROUTE_NAME}
    apiUrl={API_URL}
    label={(item) => `AI Layer (#${item.id}): ${item.name}`}
  />
)

export default AILayerDelete
